import { Text } from '@mantine/core';

import styles from './ModalOptionButton.module.scss';
import { Props } from './ModalOptionButton.types';

const ModalOptionButton = ({ icon, title, description, onClick }: Props) => {
  return (
    <button type="button" className={styles.container} onClick={onClick}>
      <div className={styles.iconContainer}>{icon}</div>
      <div className={styles.textContainer}>
        <Text className={styles.title}>{title}</Text>
        {description && <Text className={styles.description}>{description}</Text>}
      </div>
    </button>
  );
};

export default ModalOptionButton;
